import { createReducer, on } from '@ngrx/store';
import { AppleDeviceApiActions } from './device-location.actions';
import { adapter, initialState } from './device-location.state';

export const MdmDeviceLocationFeatureKey = 'deviceLocation';

export const DeviceLocationReducer = createReducer(
  initialState,
  on(AppleDeviceApiActions.deviceLocationLoaded, (state, { deviceLocation }) =>
    adapter.upsertOne(deviceLocation, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDeviceLocationIds = selectIds;

export const selectDeviceLocationEntities = selectEntities;

export const selectDeviceLocation = selectAll;
